__webpack_require__.p = "/requisition-approvals-settings/referrals-hub/";